var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.32281 0.245597H0.308221C0.585407 -0.0411916 1.05225 -0.0411913 1.32943 0.231258L9.55746 8.3187L17.7855 0.216918H17.7709C18.0481 -0.0698705 18.5149 -0.0698701 18.7921 0.202579C19.0693 0.475029 19.0693 0.93389 18.7921 1.20634L10.0389 9.81V9.79566C9.74711 10.0681 9.28028 10.0681 9.00309 9.79566C8.9885 9.78132 8.9885 9.78132 8.9885 9.78132L0.235278 1.17766L0.220689 1.16332C-0.0710848 0.876532 -0.0710849 0.417671 0.2061 0.145222C0.2061 0.130882 0.2061 0.130882 0.2061 0.130882L0.32281 0.245597Z",
    fill: "#EBBC13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownarrow);
export default __webpack_public_path__ + "static/media/dropdownarrow.c8ed332e9061945926a7f83276ccb13d.svg";
export { ForwardRef as ReactComponent };